$(document).ready(function () {
  ("use strict");

  // Menú: afegim botó i ocultem menú quan hi ha js
  $(".main-header__tools").append(
    '<button class="hamburger hamburger--spring" type="button" aria-expanded="false" aria-controls="menu" id="main-nav-btn"><span class="hamburger-box"><span class="hamburger-inner"></span></span><span class="is-sr-only">Menú</span></button>'
  );
  $("#menu").attr("hidden", "true");

  // ----
  // menú (https://polypane.rocks/blog/the-perfect-responsive-menu-2019/)
  // ----
  var toggleMenu = document.querySelector(".hamburger");
  var menu = document.querySelector("#menu");

  if (toggleMenu) {
    toggleMenu.addEventListener("click", function () {
      var open = JSON.parse(toggleMenu.getAttribute("aria-expanded"));
      toggleMenu.setAttribute("aria-expanded", !open);
      menu.hidden = !menu.hidden;
    });
  }

  $(".hamburger").on("click", function () {
    // afegir classe al botó
    $(this).toggleClass("is-active");
    // afegir classe al body
    $("html").toggleClass("js-menu-open");
  });

  // Cercador
  (function () {
    var $searchForm = $(".search-box");
    var $searchInput = $searchForm.find(".input-search");
    var $searchButton = $searchForm.find(".btn-search");

    function isSearchInputExpanded() {
      if (!$searchInput.length) return false;
      var width = parseFloat(
        window.getComputedStyle($searchInput[0]).width || "0"
      );
      // The input is considered expanded when it is wider than the collapsed size.
      return width > 50;
    }

    $searchButton.on("click", function (event) {
      if (!isSearchInputExpanded()) {
        // First click: expand the input (via CSS) and focus it.
        event.preventDefault();
        $searchInput.focus();
      }
    });
  })();

  // -------------------------------
  // Menú principal amb desplegables (https://www.w3.org/WAI/tutorials/menus/flyout/#use-button-as-toggle)
  // -------------------------------

  var menuItems = document.querySelectorAll("#menu li.has-submenu");
  Array.prototype.forEach.call(menuItems, function (el, i) {
    var activatingA = el.querySelector("a");
    var btn =
      '<button class="pt-xs pb-xs pl-xs"><span><span class="is-sr-only">Mostra el submenú per “' +
      activatingA.text +
      "”</span></span></button>";
    activatingA.insertAdjacentHTML("afterend", btn);
    // activatingA.setAttribute("aria-expanded", "false");

    el.querySelector("button").addEventListener("click", function (event) {
      var currentMenu = this.parentNode;
      Array.prototype.forEach.call(menuItems, function (el, i) {
        if (currentMenu !== el) {
          el.classList.remove("open");
          el.classList.add("close");
          //el.querySelector("a").setAttribute("aria-expanded", "false");
          el.querySelector("button").setAttribute("aria-expanded", "false");
        }
      });
      //console.log(this.parentNode.className);
      if (this.parentNode.classList.contains("close")) {
        this.parentNode.classList.add("open");
        this.parentNode.classList.remove("close");
        /*this.parentNode
          .querySelector("a")
          .setAttribute("aria-expanded", "true");*/
        this.parentNode
          .querySelector("button")
          .setAttribute("aria-expanded", "true");
      } else {
        this.parentNode.classList.add("close");
        this.parentNode.classList.remove("open");
        /*this.parentNode
          .querySelector("a")
          .setAttribute("aria-expanded", "false");*/
        this.parentNode
          .querySelector("button")
          .setAttribute("aria-expanded", "false");
      }
      event.preventDefault();
    });
  });

  // // ----
  // // menú (https://polypane.rocks/blog/the-perfect-responsive-menu-2019/)
  // // ----
  // var toggleMenu = document.querySelector(".hamburger");
  // var menu = document.querySelector("#menu");

  // if (toggleMenu) {
  //   toggleMenu.addEventListener("click", function () {
  //     var open = JSON.parse(toggleMenu.getAttribute("aria-expanded"));
  //     toggleMenu.setAttribute("aria-expanded", !open);
  //     menu.hidden = !menu.hidden;
  //   });
  // }

  // $(".hamburger").on("click", function () {
  //   // afegir classe al botó
  //   $(this).toggleClass("is-active");
  //   // afegir classe al body
  //   $("html").toggleClass("js-menu-open");
  // });

  // // -------------------------------
  // // Menú principal amb desplegables (https://www.w3.org/WAI/tutorials/menus/flyout/#use-button-as-toggle)
  // // -------------------------------

  // function hasClass(el, className) {
  //   return el.classList
  //     ? el.classList.contains(className)
  //     : new RegExp("(^| )" + className + "( |$)", "gi").test(el.className);
  // }

  // var menuItems1 = document.querySelectorAll("li.has-submenu");
  // var timer1, timer2;

  // var parseHTML = function (str) {
  //   var tmp = document.implementation.createHTMLDocument();
  //   tmp.body.innerHTML = str;
  //   return tmp.body.children;
  // };

  // Array.prototype.forEach.call(menuItems1, function (el, i) {
  //   var activatingA = el.querySelector("a");
  //   var btn =
  //     '<button type="button"><span class="is-sr-only">Mostra el submenú de “' +
  //     activatingA.text +
  //     "”</span></button>";
  //   activatingA.insertAdjacentHTML("afterend", btn);

  //   // Handle hover event for non-touch devices
  //   el.addEventListener("mouseover", function (event) {
  //     this.classList.add("open");
  //     this.querySelector("a").setAttribute("aria-expanded", "true");
  //     this.querySelector("button").setAttribute("aria-expanded", "true");
  //     clearTimeout(timer1);
  //   });

  //   el.addEventListener("mouseout", function (event) {
  //     timer1 = setTimeout(function () {
  //       var openMenu = document.querySelector(".has-submenu.open");
  //       if (openMenu) {
  //         openMenu.querySelector("a").setAttribute("aria-expanded", "false");
  //         openMenu
  //           .querySelector("button")
  //           .setAttribute("aria-expanded", "false");
  //         openMenu.classList.remove("open");
  //       }
  //     }, 500);
  //   });

  //   // Handle click and touchstart events for touch devices
  //   el.querySelector("button").addEventListener("click", function (event) {
  //     event.preventDefault();
  //     toggleSubmenu(el);
  //   });

  //   el.querySelector("button").addEventListener("touchstart", function (event) {
  //     event.preventDefault();
  //     toggleSubmenu(el);
  //   });

  //   var links = el.querySelectorAll("a");
  //   Array.prototype.forEach.call(links, function (link, i) {
  //     link.addEventListener("focus", function () {
  //       if (timer2) {
  //         clearTimeout(timer2);
  //         timer2 = null;
  //       }
  //     });
  //     link.addEventListener("blur", function (event) {
  //       timer2 = setTimeout(function () {
  //         var openNav = document.querySelector(".has-submenu.open");
  //         if (openNav) {
  //           openNav.className = "has-submenu";
  //           openNav.querySelector("a").setAttribute("aria-expanded", "false");
  //           openNav
  //             .querySelector("button")
  //             .setAttribute("aria-expanded", "false");
  //         }
  //       }, 10);
  //     });
  //   });
  // });

  // function toggleSubmenu(el) {
  //   var isOpen = hasClass(el, "open");

  //   // Close any other open submenus
  //   var allMenus = document.querySelectorAll("li.has-submenu");
  //   Array.prototype.forEach.call(allMenus, function (item) {
  //     item.classList.remove("open");
  //     item.querySelector("a").setAttribute("aria-expanded", "false");
  //     item.querySelector("button").setAttribute("aria-expanded", "false");
  //   });

  //   // Open the clicked/touched submenu if it was not already open
  //   if (!isOpen) {
  //     el.classList.add("open");
  //     el.querySelector("a").setAttribute("aria-expanded", "true");
  //     el.querySelector("button").setAttribute("aria-expanded", "true");
  //   }
  // }

  // ---------
  // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
  // ---------

  // bind a click event to the 'skip' link
  $(".skip-link").click(function (event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = "#" + this.href.split("#")[1];

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo)
      .attr("tabindex", -1)
      .on("blur focusout", function () {
        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr("tabindex");
      })
      .focus(); // focus on the content container
  });

  // ----------
  // scroll top
  // ----------
  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      $(".scrolltop").addClass("visible");
    } else {
      $(".scrolltop").removeClass("visible");
    }
  });

  // ------
  // Slider
  // ------
  $(".slider").slick({
    dots: true,
    arrows: true,
    autoplay: false,
    // autoplaySpeed: 8000,
  });

  // ------
  // Swiper
  // ------
  const swiper1 = new Swiper('.swiper-noticies', {
    // loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    // autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: true
    // },
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
  });

  const swiper2 = new Swiper('.swiper-instalacions', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
  });

  // --------
  // Counters https://github.com/srexi/purecounterjs
  // --------
  new PureCounter({
    // selector: '.purecounter',
    // start: 0,
    // end: 100,
    // duration: 2,
    // delay: 10,
    // once: true,
    // repeat: false,
    // decimals: 0,
    legacy: false,
    // filesizing: false,
    // currency: false,
    separator: true,
  });

  // ----------------------------------------------------
  // Crea elements span per poder fer text dins de cercle
  // ----------------------------------------------------
  (function () {
    var $items = $("p.highlighted-p-2");
    if (!$items.length) return;

    $items.each(function () {
      var p = this;
      var text = p.textContent;
      var outerSpan = document.createElement("span");
      var innerSpan = document.createElement("span");
      innerSpan.textContent = text;
      p.textContent = "";
      outerSpan.appendChild(innerSpan);
      p.appendChild(outerSpan);
    });
  })();

  // --------------
  // Navegació fixa
  // --------------
  function checkSiteLogoVisibility() {
    const siteLogo = $(".site-logo");
    const nav = $("nav.navigation");

    if(siteLogo) {
      const logoTop = siteLogo.offset().top - $(window).scrollTop();
      const logoBottom = logoTop + siteLogo.outerHeight();

      if (logoBottom <= 0) {
        nav.addClass("fixed");
      } else {
        nav.removeClass("fixed");
      }
    }
    
  }

  $(window).on("scroll", checkSiteLogoVisibility);

  checkSiteLogoVisibility();

  // --------
  // headroom
  // --------
  // $(".main-header").headroom(
  // {
  // offset: 0,
  // tolerance: 5,
  // classes: {
  //   initial: "animated",
  //   pinned: "slideDown",
  //   unpinned: "slideUp"
  // }
  // }
  // );

  // --------
  // timeline
  // --------
  $(".timeline").timelify({
    animLeft: "fadeInLeft",
    animCenter: "fadeInUp",
    animRight: "fadeInRight",
    animSpeed: 600,
    offset: 150,
  });


  // -----------
  // File upload
  // -----------
  $('input[type="file"]').change(function () {
    var i = $(this).next().find(".file-label").clone();
    var file = $('input[type="file"]')[0].files[0].name;
    $(this).next().find(".file-label").text(file);
  });

  // ----
  // Tabs https://inclusive-components.design/tabbed-interfaces/
  // ----
  // if ($(".tabbed").length > 0) {
  //   $(".tabbed").each(function (index, element) {
  //     // Get relevant elements and collections
  //     var tabbed = element;
  //     var tablist = tabbed.querySelector("ul.tab-menu");
  //     var tabs = tablist.querySelectorAll("a");
  //     var panels = tabbed.querySelectorAll(".tab-panel");

  //     // The tab switching function
  //     var switchTab = function switchTab(oldTab, newTab) {
  //       newTab.focus(); // Make the active tab focusable by the user (Tab key)

  //       newTab.removeAttribute("tabindex"); // Set the selected state

  //       newTab.setAttribute("aria-selected", "true");
  //       oldTab.removeAttribute("aria-selected");
  //       oldTab.setAttribute("tabindex", "-1"); // Get the indices of the new and old tabs to find the correct
  //       // tab panels to show and hide

  //       var index = Array.prototype.indexOf.call(tabs, newTab);
  //       var oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
  //       panels[oldIndex].hidden = true;
  //       panels[index].hidden = false;
  //     }; // Add the tablist role to the first <ul> in the .tabbed container

  //     tablist.setAttribute("role", "tablist"); // Add semantics are remove user focusability for each tab

  //     Array.prototype.forEach.call(tabs, function (tab, i) {
  //       tab.setAttribute("role", "tab");
  //       //	    tab.setAttribute("id", "tab" + (i + 1));
  //       tab.setAttribute("tabindex", "-1");
  //       tab.parentNode.setAttribute("role", "presentation"); // Handle clicking of tabs for mouse users

  //       tab.addEventListener("click", function (e) {
  //         e.preventDefault();
  //         var currentTab = tablist.querySelector("[aria-selected]");

  //         if (e.currentTarget !== currentTab) {
  //           switchTab(currentTab, e.currentTarget);
  //         }
  //       }); // Handle keydown events for keyboard users

  //       tab.addEventListener("keydown", function (e) {
  //         // Get the index of the current tab in the tabs node list
  //         var index = Array.prototype.indexOf.call(tabs, e.currentTarget); // Work out which key the user is pressing and
  //         // Calculate the new tab's index where appropriate

  //         var dir =
  //           e.which === 37
  //             ? index - 1
  //             : e.which === 39
  //               ? index + 1
  //               : e.which === 40
  //                 ? "down"
  //                 : null;

  //         if (dir !== null) {
  //           e.preventDefault(); // If the down key is pressed, move focus to the open panel,
  //           // otherwise switch to the adjacent tab

  //           dir === "down"
  //             ? panels[i].focus()
  //             : tabs[dir]
  //               ? switchTab(e.currentTarget, tabs[dir])
  //               : void 0;
  //         }
  //       });
  //     }); // Add tab panel semantics and hide them all

  //     Array.prototype.forEach.call(panels, function (panel, i) {
  //       panel.setAttribute("role", "tabpanel");
  //       panel.setAttribute("tabindex", "-1");
  //       var id = panel.getAttribute("id");
  //       panel.setAttribute("aria-labelledby", tabs[i].id);
  //       panel.hidden = true;
  //     }); // Initially activate the first tab and reveal the first tab panel

  //     tabs[0].removeAttribute("tabindex");
  //     tabs[0].setAttribute("aria-selected", "true");
  //     panels[0].hidden = false;
  //   });
  // }
});

// -----------
// Collapsible (https://inclusive-components.design/collapsible-sections/)
// -----------
(function () {
  // Get all the headings
  const headings = document.querySelectorAll(".collapsible__title");

  Array.prototype.forEach.call(headings, (heading) => {
    // Give each <h2> a toggle button child
    // with the SVG plus/minus icon
    heading.innerHTML = `
      <button aria-expanded="false" class="is-flex is-justify-content-space-between is-align-items-center py-5 pl-5 pr-3 gap-2">
        ${heading.textContent}
        <svg class="is-flex-shrink-0" aria-hidden="true" focusable="false" width="14" height="8" xmlns="http://www.w3.org/2000/svg"><path d="m13.002 1-6 6L1 1" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    `;
    // Function to create a node list
    // of the content between this heading and the next
    const getContent = (elem) => {
      let elems = [];
      while (
        elem.nextElementSibling &&
        elem.nextElementSibling.className !== "collapsible__title"
      ) {
        elems.push(elem.nextElementSibling);
        elem = elem.nextElementSibling;
      }

      // Delete the old versions of the content nodes
      elems.forEach((node) => {
        node.parentNode.removeChild(node);
      });

      return elems;
    };

    // Assign the contents to be expanded/collapsed (array)
    let contents = getContent(heading);

    // Create a wrapper element for `contents` and hide it
    let wrapper = document.createElement("div");
    wrapper.hidden = true;

    // Add each element of `contents` to `wrapper`
    contents.forEach((node) => {
      wrapper.appendChild(node);
    });

    // Add the wrapped content back into the DOM
    // after the heading
    heading.parentNode.insertBefore(wrapper, heading.nextElementSibling);

    // Assign the button
    let btn = heading.querySelector("button");

    btn.onclick = () => {
      // Cast the state as a boolean
      let expanded = btn.getAttribute("aria-expanded") === "true" || false;

      // Switch the state
      btn.setAttribute("aria-expanded", !expanded);
      // Switch the content's visibility
      wrapper.hidden = expanded;
    };
  });

  if (
    $(".collapsible__title").length > 0 &&
    window.location.hash.indexOf("#entry-") > -1 &&
    $(window.location.hash).length > 0
  ) {
    $(window.location.hash).find("button").attr("aria-expanded", true);
    $(window.location.hash).next().show();
    $("html, body").animate(
      {
        scrollTop: $(window.location.hash).parent().offset().top,
      },
      1000
    );
  }
})();
